import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DataSharingService } from 'src/app/middleware/common/resuableServices/data-sharing.service';

@Component({
  selector: 'app-side-navigation',
  templateUrl: './side-navigation.component.html',
  styleUrls: ['./side-navigation.component.scss']
})
export class SideNavigationComponent implements OnInit {

  permissionAsssign: any[] = [];
  rolesAsssign: any[] = [];
  customize: boolean = true;
  expand: boolean = false; 
  showUser: boolean = false;
  showPermission: boolean = false;
  showRole: boolean = false;
  showOrganization: boolean = false;
  showModule: boolean = false;
  rolesShow:boolean=false;
  showLoginDetails:boolean=false;
  
  constructor(private _dataSharingService:DataSharingService,  private router: Router) {
  }

  ngOnInit(): void {
    this.permissionAsssign = JSON.parse(sessionStorage.getItem("permissions"));
    this.rolesAsssign = JSON.parse(sessionStorage.getItem("roles"));

    if(this.rolesAsssign.length > 0){
      var role=[];
       // roleLevel:1 (Super admin), roleLevel:2 (Organization Admin), roleLevel:3 (Office Admin),
       // roleLevel:11 (User)
      role= this.rolesAsssign.filter((m) => m.roleLevel == 1);
      if(role.length > 0){
        this.showUser=true;
        this.showPermission=true;
        this.showRole=true;
        this.showModule=true;
        this.showLoginDetails=true;
         return;
     }
     role= this.rolesAsssign.filter((m) => m.roleLevel == 2);
     if(role.length > 0){
      this.showUser=true;
      this.showPermission=false;
      this.showRole=true;
      this.showModule=false;
      this.showLoginDetails=false;
     }

     role= this.rolesAsssign.filter((m) => m.roleLevel == 3);
     if(role.length > 0){
      this.showUser=true;
      this.showPermission=false;
      this.showRole=false;
      this.showModule=false;
      this.showLoginDetails=false;
     }

    }
    
  //   if(this.rolesAsssign.length > 0){
  //     var role=[];
  //     role= this.rolesAsssign.filter((m) => m.roleLevel == 1);
  //     if(role.length > 0){
  //     this.rolesShow=true;
  //    }else{
  //     this.rolesShow=false;
  //    }
  //   }

  //   if(this.rolesShow==true){
  //     this.showUser=true;
  //     this.showPermission=true;
  //     this.showRole=true;
  //     this.showOrganization=true;
  //     this.showModule=true; 
  //     return;
  //   }

  //   if(this.rolesShow==false){
  //     if(this.permissionAsssign.length > 0){
  //       for (var i = 0, len = this.permissionAsssign.length; i < len; ++i) {
  //         var menu = this.permissionAsssign[i].permissionName;
                 
  //         if(menu == "User"){
  //           this.showUser=true;  
  //         }
  //         if(menu == "Permission"){
  //           this.showPermission=true;  
  //         }
  //         if(menu == "Role"){
  //           this.showRole=true;  
  //         }
  //         if(menu == "Organization" && this.rolesShow!=false){
  //           this.showOrganization=true;  
  //         }
  //         if(menu == "Module" && this.rolesShow!=false){
  //           this.showModule=true;  
  //         }
  //      } 
  //   } 
  //  }
   

  }

  openOrg(){
    sessionStorage.setItem('HeaderModuleName', 'Organization');   
    this._dataSharingService.sendSelectedModuleName('Organization');
    this.router.navigate(['/organization']);
  }


  expandNav(){
    this.expand = !this.expand
  }

  navItems = [
    {
      id: '0',
      name : 'Admin',
      items :[
        {
          name: 'Users',
          link: '/admin',
        },
        {
          name: 'Permissions',
          link: 'permissions'
        },
        {
          name: 'Roles',
          link: 'role'
        },
        {
          name: 'Organization',
          link: 'organization'
        },
        {
          name: 'Module',
          link: 'module'
        }
      ]
    }
  ];  

}
